// public/js/modules/store.js




import { create } from 'https://esm.sh/zustand';




export const useAppStore = create((set) => ({
  
  
  currentLoadedSongId: null,
  currentArtistId: null,
  hasCurrentSongBeenPlayed: false,


  isLiveShow: false,
  
  
  isGuest: false,
  guestData: null,
  guestName: null,

  
  
  currentShowId: null,

  
  
  
  
setCurrentLoadedSongId: (songId) => set({ currentLoadedSongId: songId }),
  setCurrentArtistId: (artistId) => set({ currentArtistId: artistId }),
  setHasCurrentSongBeenPlayed: (played) => set({ hasCurrentSongBeenPlayed: played }),
  setIsLiveShow: (isLive) => set({ isLiveShow: isLive }),
  setIsGuest: (isGuest) => set({ isGuest }),
  setGuestData: (data) => set({ guestData: data }),
  setGuestName: (name) => set({ guestName: name }),
  setCurrentShowId: (showId) => set({ currentShowId: showId }),

  dmUnreadCount: 0,
  setDmUnreadCount: (count) => set({ dmUnreadCount: count }),

}));


if (typeof window !== 'undefined') {
    window.useAppStore = useAppStore;
}